/* Build a Reversible - show the customer's actual towel in the cart.

   The product has no image of its own (every towel is a one-off), so Shopify
   renders an empty media cell. There is no server to generate a thumbnail on,
   but there does not need to be: the cart line already carries the two design
   keys and any hue angles, and every layer photograph is a theme asset. So the
   same composite the product page drew is rebuilt here, client side.

   Covers the cart PAGE and the cart DRAWER - both use .cart-item__media - and
   redraws after Shopify swaps those sections on quantity changes.

   Colours match the product page exactly: the same feColorMatrix hueRotate,
   with the same fallback for browsers where ctx.filter does nothing (Safari
   before 17), so the thumbnail cannot disagree with what they configured. */
(function () {
  'use strict';

  var THIS = document.currentScript && document.currentScript.src;
  if (!THIS) return;
  var BASE = THIS.replace(/[^/]*$/, '');          // .../assets/

  /* Shopify's CDN caches each asset URL separately, and the BARE url can be
     hours stale - it served a catalogue with no layers block while the real
     one was current, which silently produced no thumbnail at all. This script
     is itself loaded through asset_url, so borrow its version token for every
     asset we fetch: fresh whenever the theme changes, cacheable in between. */
  var VER = THIS.indexOf('?') >= 0 ? THIS.slice(THIS.indexOf('?')) : '';
  function asset(name) { return BASE + name + VER; }
  var WIDTH = 260;                                 // ~130px on screen, retina
  var MARK = 'data-rb-thumb';

  // ---- the same hue transform the picker uses ----------------------------
  var CANVAS_FILTER = (function () {
    try {
      var a = document.createElement('canvas'); a.width = a.height = 1;
      var ax = a.getContext('2d');
      ax.fillStyle = '#ff0000'; ax.fillRect(0, 0, 1, 1);
      var b = document.createElement('canvas'); b.width = b.height = 1;
      var bx = b.getContext('2d', { willReadFrequently: true });
      bx.filter = 'hue-rotate(180deg)';
      bx.drawImage(a, 0, 0);
      return bx.getImageData(0, 0, 1, 1).data[0] < 200;
    } catch (e) { return false; }
  })();

  function hueMatrix(deg) {
    var a = deg * Math.PI / 180, c = Math.cos(a), s = Math.sin(a);
    return [0.213 + c * 0.787 - s * 0.213, 0.715 - c * 0.715 - s * 0.715, 0.072 - c * 0.072 + s * 0.928,
            0.213 - c * 0.213 + s * 0.143, 0.715 + c * 0.285 + s * 0.140, 0.072 - c * 0.072 - s * 0.283,
            0.213 - c * 0.213 - s * 0.787, 0.715 - c * 0.715 + s * 0.715, 0.072 + c * 0.928 + s * 0.072];
  }

  function drawHued(ctx, img, deg, w, h) {
    if (!deg) { ctx.drawImage(img, 0, 0, w, h); return; }
    if (CANVAS_FILTER) {
      ctx.filter = 'hue-rotate(' + deg + 'deg)';
      ctx.drawImage(img, 0, 0, w, h);
      ctx.filter = 'none';
      return;
    }
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, w, h);
    var d;
    try { d = x.getImageData(0, 0, w, h); } catch (e) { ctx.drawImage(img, 0, 0, w, h); return; }
    var px = d.data, m = hueMatrix(deg);
    for (var i = 0; i < px.length; i += 4) {
      var r = px[i], g = px[i + 1], b = px[i + 2];
      px[i]     = m[0] * r + m[1] * g + m[2] * b;
      px[i + 1] = m[3] * r + m[4] * g + m[5] * b;
      px[i + 2] = m[6] * r + m[7] * g + m[8] * b;
    }
    x.putImageData(d, 0, 0);
    ctx.drawImage(c, 0, 0, w, h);
  }

  // ---- assets ------------------------------------------------------------
  var catP = null;
  function catalogue() {
    if (!catP) {
      catP = fetch(asset('reversible-catalog.json'))
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }
    return catP;
  }

  var imgs = {};
  function load(name) {
    if (!imgs[name]) {
      imgs[name] = new Promise(function (res, rej) {
        var i = new Image();
        i.onload = function () { res(i); };
        i.onerror = rej;
        i.src = asset(name);
      });
    }
    return imgs[name];
  }

  function deg(v) {
    var n = parseInt(v, 10);
    return isFinite(n) ? ((n % 360) + 360) % 360 : 0;
  }

  /* -> a data URL of the towel, cropped to the towel itself so the thumbnail
        is not mostly backdrop. */
  function build(p) {
    return catalogue().then(function (cat) {
      if (!cat || !cat.layers || !cat.mockup) throw new Error('no geometry');
      var fk = p._front_key, bk = p._back_key;
      var known = {};
      (cat.designs || []).forEach(function (d) { known[d.key] = d; });
      if (!known[fk] || !known[fk].layers) throw new Error('front has no layers');

      var W = cat.layers.width, H = cat.layers.height;
      var wants = [load(cat.layers.mask), load('rb-body-' + fk + '.jpg')];
      wants.push(bk && known[bk] && known[bk].layers
        ? load('rb-corner-' + bk + '.jpg')
        : load(cat.mockup.assets.blank));

      return Promise.all(wants).then(function (im) {
        var mask = im[0], body = im[1], corner = im[2];
        var full = document.createElement('canvas');
        full.width = W; full.height = H;
        var c = full.getContext('2d');

        drawHued(c, corner, deg(p._back_hue), W, H);

        var off = document.createElement('canvas');
        off.width = W; off.height = H;
        var o = off.getContext('2d');
        drawHued(o, body, deg(p._front_hue), W, H);
        o.globalCompositeOperation = 'destination-in';
        o.drawImage(mask, 0, 0, W, H);
        o.globalCompositeOperation = 'source-over';
        c.drawImage(off, 0, 0);

        // Crop to the towel, with a little air around it.
        var t = cat.mockup.towel, pad = 0.02;
        var sx = Math.max(0, (t.x - pad) * W), sy = Math.max(0, (t.y - pad) * H);
        var sw = Math.min(W - sx, (t.w + pad * 2) * W);
        var sh = Math.min(H - sy, (t.h + pad * 2) * H);
        var out = document.createElement('canvas');
        out.width = WIDTH;
        out.height = Math.round(WIDTH * sh / sw);
        out.getContext('2d').drawImage(full, sx, sy, sw, sh, 0, 0, out.width, out.height);
        return out.toDataURL('image/jpeg', 0.86);
      });
    });
  }

  // ---- putting it in the cart -------------------------------------------
  /* The cart PAGE puts data-item-key on the product link, but the DRAWER does
     not - it only has id="CartDrawer-Item-N". Both number from 1 in cart
     order, so fall back to that index. Missing this is why the drawer showed
     an empty cell while the page showed the towel. */
  function targets() {
    var out = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('[id^="CartItem-"], [id^="CartDrawer-Item-"]'),
      function (row) {
        var td = row.querySelector('.cart-item__media');
        if (!td) return;
        var a = row.querySelector('[data-item-key]');
        var m = /-(\d+)$/.exec(row.id);
        out.push({
          td: td,
          key: a ? a.getAttribute('data-item-key') : null,
          index: m ? parseInt(m[1], 10) : null
        });
      });
    return out;
  }

  var busy = false;
  function paint() {
    if (busy) return;
    var found = targets();
    if (!found.length) return;

    // The observer fires on any DOM change on the page, so do not reach for
    // /cart.js unless something is actually unpainted. Shopify replaces the
    // whole row when a line changes, and a fresh row has no mark, so this
    // cannot go stale.
    var pending = found.some(function (t) { return !t.td.hasAttribute(MARK); });
    if (!pending) return;

    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var byKey = {};
        (cart.items || []).forEach(function (i) { byKey[i.key] = i; });
        var jobs = [];
        found.forEach(function (t) {
          var item = (t.key && byKey[t.key]) ||
                     (t.index ? (cart.items || [])[t.index - 1] : null);
          if (!item || !item.properties || !item.properties._front_key) return;
          var td = t.td;
          var sig = item.properties._front_key + '|' + (item.properties._back_key || '') +
                    '|' + (item.properties._front_hue || 0) + '|' + (item.properties._back_hue || 0);
          if (td.getAttribute(MARK) === sig) return;      // already correct
          jobs.push(build(item.properties).then(function (url) {
            td.setAttribute(MARK, sig);
            var img = td.querySelector('img[' + MARK + '-img]');
            if (!img) {
              /* Take over the theme's OWN <img> rather than adding a second
                 one. The product has a picture of its own now, so appending
                 showed the customer their towel AND the stock image side by
                 side. Adopting it also keeps the theme's cell layout. */
              var own = td.querySelector('img.cart-item__image') ||
                        td.querySelector('img');
              if (own) {
                Array.prototype.forEach.call(td.querySelectorAll('source'),
                  function (sc) { sc.parentNode.removeChild(sc); });
                own.removeAttribute('srcset');
                own.removeAttribute('sizes');
                // The stock image is a different shape from the towel; drop the
                // fixed dimensions so ours is not squashed into them.
                own.removeAttribute('width');
                own.removeAttribute('height');
                own.style.width = '100%';
                own.style.height = 'auto';
                own.setAttribute(MARK + '-img', '');
                img = own;
              } else {
                img = new Image();
                img.setAttribute(MARK + '-img', '');
                img.alt = '';
                img.loading = 'lazy';
                img.style.cssText =
                  'display:block;width:100%;height:auto;border-radius:3px';
                td.appendChild(img);
              }
            }
            img.src = url;
          }).catch(function (err) {
            if (window.console) {
              console.warn('[reversible] cart thumbnail failed:', err && err.message);
            }
          }));
        });
        return Promise.all(jobs);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  var timer = 0;
  function soon() { clearTimeout(timer); timer = setTimeout(paint, 120); }

  function start() {
    soon();
    // Shopify replaces the cart sections wholesale on quantity or removal, and
    // the drawer is injected long after load, so watch for both.
    new MutationObserver(soon).observe(document.documentElement,
      { childList: true, subtree: true });
    document.addEventListener('cart:refresh', soon);
    document.addEventListener('cart:updated', soon);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
